import React, { useState } from "react";
import { Box } from "@mui/material";
import Button from "../../../components/Comon/Button/Button";
import practiceLogo from "../../../../../src/hubLogo.png";
import PracticeHubIncomingIntegration from "../../../components/PracticeHubIncomingIntegration";
import PracticeHubOutgoingIntegration from "../../../components/PracticeHubOutgoingIntegration";

export const Integrations = ({ app, i18n, showGlobalSnackbar }) => {
  const [isOutgoingOpen, setIsOutgoingOpen] = useState(false);
  const [isIncomingOpen, setIsIncomingOpen] = useState(false);

  return (
    <div className="integrations">
      <Box className={"mainProfile"}>

          <div
              style={{
                  maxWidth:'650px',
                  padding: "20px",
                  borderRadius: "10px",
                  backgroundColor: "rgba(231, 71, 44, 0.21)",
              }}
          >
              <img src={practiceLogo} alt={"PracticeHub"} style={{width:'200px', marginLeft:'-12px'}} />

              <div
                  className={"textInputContainer"}
                  style={{
                      marginTop:'15px',
                      width:"100%",
                      display: "flex",
                      gap: "17px",
                      alignItems: "center",
                  }}
              >
                  <img
                      style={{ alignSelf: "flex-start" }}
                      className={"additionalPlanIcon"}
                      src={"/assets/info_icon_gray.svg"}
                      alt="additionalPlanIcon"
                  />
                  <p
                      style={{
                          color: "rgba(73, 73, 73, 1)",
                          fontFamily: "HelveticaNeueRegular",
                          fontSize: "16px",
                          fontWeight: "400",
                          letterSpacing: "0px",
                          textAlign: "left",
                          lineHeight: "21px",
                          marginBottom: 0,
                      }}
                  >
                      To learn more about how the integration works, please click the
                      button to read the details.
                  </p>
                  <Box
                      className={"buttonContainer"}
                      style={{
                          marginTop: "0",
                          flexShrink: 0,
                      }}
                      onClick={() =>
                          window.open(
                              "/assets/documents/What You Need to Know for a PracticeHub Integration.pdf",
                              "_blank"
                          )
                      }
                  >
                      <Button text={"READ ME FIRST"} mode={"small"} color={"white"} />
                  </Box>
              </div>
          </div>


        <div className="practiceHubAccordionCards">
          <div className="practiceHubAccordionCard">
            <div
              className="practiceHubAccordionHeader"
              onClick={() => setIsOutgoingOpen(!isOutgoingOpen)}
            >
              <div className="practiceHubAccordionToggleIcon">
                <img
                  src={
                    isOutgoingOpen
                      ? "/assets/ic_dropdown-up.svg"
                      : "/assets/ic_dropdown-down.svg"
                  }
                  alt={"toggle"}
                />
              </div>
              <div className="practiceHubAccordionText">
                <h3>Share with PracticeHub (outgoing)</h3>
                <p>
                  Generate a unique link and manage default survey options used
                  for outgoing PracticeHub automation.
                </p>
              </div>
            </div>

            {isOutgoingOpen && (
              <div className="practiceHubAccordionBody">
                <PracticeHubOutgoingIntegration
                  app={app}
                  i18n={i18n}
                  showGlobalSnackbar={showGlobalSnackbar}
                />
              </div>
            )}
          </div>

          <div className="practiceHubAccordionCard">
            <div
              className="practiceHubAccordionHeader"
              onClick={() => setIsIncomingOpen(!isIncomingOpen)}
            >
              <div className="practiceHubAccordionToggleIcon">
                <img
                  src={
                    isIncomingOpen
                      ? "/assets/ic_dropdown-up.svg"
                      : "/assets/ic_dropdown-down.svg"
                  }
                  alt={"toggle"}
                />
              </div>
              <div className="practiceHubAccordionText">
                <h3>Connect to PracticeHub (incoming)</h3>
                <p>
                  Enter your PracticeHub API credentials so our system can talk
                  to PracticeHub.
                </p>
              </div>
            </div>

            {isIncomingOpen && (
              <div className="practiceHubAccordionBody">
                <PracticeHubIncomingIntegration
                  app={app}
                  i18n={i18n}
                  showGlobalSnackbar={showGlobalSnackbar}
                />
              </div>
            )}
          </div>
        </div>
      </Box>
    </div>
  );
};
